module.exports = __webpack_public_path__ + "img/sdg-1.a0213b6c.jpeg";